import ApiAuthorzationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import Dashboard from "./components/Dashboard";
import  Login  from './components/Login';
import { PrivateRoute } from './components/PrivateRoute';
import { Route, Routes ,Navigate, useNavigate, useLocation} from 'react-router-dom';
import  Layout  from './components/Layout';
import  Invoices  from './components/Invoices';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import BrunchDiningIcon from '@mui/icons-material/BrunchDining';
import DashboardIcon from '@mui/icons-material/Dashboard';
import Invoice from './components/Invoice';
import ST from './components/ST';
import ReturnedInvoice from './components/ReturnedInvoice';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import AssignmentReturnedIcon from '@mui/icons-material/AssignmentReturned';
import GradingIcon from '@mui/icons-material/Grading';
import ReturnedInvoices from './components/ReturnedInvoices';
import AccountReview from './components/AccountReview';
import Receipts from './components/Receipts';
import { Payment } from './components/Payment';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CallBack from './components/CallBack';
import MatrixQuantity from './components/MatrixQuantity';
import RX from './components/RX';
import Orders from './components/orders';
import AnimationIcon from '@mui/icons-material/Animation';
import BuildIcon from '@mui/icons-material/Build';
import ListIcon from '@mui/icons-material/List';
import { DeviceHub } from '@mui/icons-material';
import SaleDepartment from './components/SaleDepartment';
import MyOrders from './components/MyOrders';
import { MyWaitingOrders } from './components/MyWaitingOrders';
import PaymentResult from './components/PaymentResult';
import ChangePass from './components/ChangePass';
import PasswordIcon from '@mui/icons-material/Password';
const AppRoutes = [
  //{
  //  index: true,
  //  element: <Dashboard />
  //},
  //{
  //  path:"/NewDashboard",
  //  element:(
  //      <NewDashboard />
  //  ),
   // title : 'داشبورد',
   // name: 'newdashboard',
  //  route : "/NewDashboard",
  //  type : "MainMenuItem",
  //  key : 'newdashboard',
  //  icon : <DashboardIcon />
  //},
  {
    path: '/login',
    element: <Login />,
    title : 'ورود',
    name: 'login',
    route : "/login",
    type : "userItem",
    key : 'login',
    icon : <DashboardIcon color="primary" />
  },
  {
    path: '/logout',
    title : 'خروج',
    name: 'logout',
    route : "/logout",
    type : "userItem",
    key : 'logout',
    icon : <DashboardIcon color="primary" />
  },
  {
    path:"/",
    element:(
        <PrivateRoute>
            <Layout>
            <Dashboard />
          </Layout>
        </PrivateRoute>
    ),
    title : 'فروش در یک نگاه',
    name: 'dashboard',
    route : "/",
    type : "FirtLevelMainMenuItem",
    key : 'dashboard',
    icon : <DashboardIcon sx={{ color: "#FDD835" }} />,
    level : '1',
    isFinancial : true
  },
  
  {
    path:"/",
    element:(
        <PrivateRoute>
            <Layout>
            <Dashboard />
          </Layout>
        </PrivateRoute>
    ),
    title : 'سفارش',
    name: 'ord',
    route : "/",
    type : "FirtLevelMainMenuItem",
    key : 'ord',
    icon : <AnimationIcon sx={{ color: "#64b5f6" }} />,
    level : '2',
    isFinancial : false
  },
  {
    path:"/ST",
    element:(
        <PrivateRoute>
            <Layout>
            <ST />
          </Layout>
        </PrivateRoute>
    ),
    title : 'ثبت سفارش عدسی موجود',
    name: 'st',
    route : "/ST",
    type : "SecondLevelMainMenuItem",
    key : 'st',
    icon : <BrunchDiningIcon sx={{ color: "#90caf9" }} />,
    level : '2-1',
    isFinancial : false
  },
  {
    path:"/STMatrix",
    element:(
        <PrivateRoute>
           
            <MatrixQuantity />
         
        </PrivateRoute>
    ),
    title : 'انتخاب از ماتریس',
    name: 'stmatrix',
    route : "/STMatrix",
    type : "SecondMenuItem",
    key : 'stmatrix',
    icon : <LoyaltyIcon sx={{ color: "#4CAF50" }} />,
    isFinancial : false
  },
 
  {
    path:"/RX",
    element:(
        <PrivateRoute>
            <Layout>
            <RX />
          </Layout>
        </PrivateRoute>
    ),
    title : 'ثبت سفارش عدسی سفارشی',
    name: 'rx',
    route : "/RX",
    type : "SecondLevelMainMenuItem",
    key : 'rx',
    icon : <LoyaltyIcon sx={{ color: "#2196f3" }} />,
    level : '2-2',
    isFinancial : false
  },
  
  {
    path:"/Orders",
    element:(
        <PrivateRoute>
            <Layout>
            <MyOrders/>
          </Layout>
        </PrivateRoute>
    ),
    title : 'سفارش های من',
    name: 'orders',
    route : "/Orders",
    type : "SecondLevelMainMenuItem",
    key : 'orders',
    icon : <ListIcon sx={{ color: "#1976d2" }} />,
    level : '2-3',
    isFinancial : false
  },
  {
    path:"/MyWaitingOrders",
    element:(
        <PrivateRoute>
            <Layout>
            <MyWaitingOrders/>
          </Layout>
        </PrivateRoute>
    ),
    title : 'سفارش های در انتظار',
    name: 'orders',
    route : "/MyWaitingOrders",
    type : "SecondLevelMainMenuItem",
    key : 'myWaitingOrders',
    icon : <ListIcon sx={{ color: "#1976d2" }} />,
    level : '2-4',
    isFinancial : true
  },
  {
    path:"/",
    element:(
        <PrivateRoute>
            <Layout>
            <Dashboard />
          </Layout>
        </PrivateRoute>
    ),
    title : 'خدمات پس از فروش',
    name: 'ass',
    route : "/",
    type : "FirtLevelMainMenuItem",
    key : 'ass',
    icon : <BuildIcon sx={{ color: "#00c853" }} />,
    level : '3',
    isFinancial : true
  },
  {
    path:"/",
    element:(
        <PrivateRoute>
            <Layout>
            <Invoices />
          </Layout>
        </PrivateRoute>
    ),
    title : 'ثبت گارانتی عدسی موجود',
    name: 'stwarranty',
    route : "/",
    type : "SecondLevelMainMenuItem",
    key : 'stwarranty',
    icon : <LoyaltyIcon sx={{ color: "#546e7a" }} />,
    level : '3-1',
    isFinancial : true
  },
  {
    path:"/",
    element:(
        <PrivateRoute>
            <Layout>
            <Invoices />
          </Layout>
        </PrivateRoute>
    ),
    title : 'ثبت گارانتی عدسی سفارشی',
    name: 'rxwarranty',
    route : "/",
    type : "SecondLevelMainMenuItem",
    key : 'rxwarranty',
    icon : <LoyaltyIcon sx={{ color: "#5d4037" }} />,
    level : '3-2',
    isFinancial : true
  },
  {
    path:"/",
    element:(
        <PrivateRoute>
          <Layout>
            <Invoices />
          </Layout>
        </PrivateRoute>
    ),
    title : 'پیگیری وضعیت',
    name: 'followwarranty',
    route : "",
    type : "SecondLevelMainMenuItem",
    key : 'followwarranty',
    icon : <ListIcon sx={{ color: "#000000" }} />,
    level : '3-3',
    isFinancial : true
  },
  {
    path: '/assets/images/signin-ill.jpg',
    element: <Navigate to="/assets/images/signin-ill.jpg" />,
    requireAuth: false,
  },
  
  {
    path:"/",
    element:(
        <PrivateRoute>
            <Layout>
            <Dashboard />
          </Layout>
        </PrivateRoute>
    ),
    title : 'مالی',
    name: 'fin',
    route : "/",
    type : "FirtLevelMainMenuItem",
    key : 'fin',
    icon : <AttachMoneyIcon sx={{ color: "#f06292" }} />,
    level : '4',
    isFinancial : true
  },
  {
    path:"/Invoices",
    element:(
        <PrivateRoute>
            <Layout>
            <Invoices />
          </Layout>
        </PrivateRoute>
    ),
    title : 'فاکتور های فروش',
    name: 'invoices',
    route : "/Invoices",
    type : "SecondLevelMainMenuItem",
    key : 'invoices',
    icon : <LoyaltyIcon sx={{ color: "#4CAF50" }} />,
    level : '4-1',
    isFinancial : true
  },
  {
    path:"/ReturnedInvoices",
    element:(
        <PrivateRoute>
            <Layout>
            <ReturnedInvoices />
          </Layout>
        </PrivateRoute>
    ),
    title : 'فاکتور های برگشتی',
    name: 'returnedinvoices',
    route : "/ReturnedInvoices",
    type : "SecondLevelMainMenuItem",
    key : 'returnedinvoices',
    icon : <AssignmentReturnedIcon sx={{ color: "#7B1FA2" }} />,
    level : '4-2',
    isFinancial : true
  },
  {
    path:"/AccountReview",
    element:(
        <PrivateRoute>
            <Layout>
            <AccountReview />
          </Layout>
        </PrivateRoute>
    ),
    title : 'گردش حساب',
    name: 'accountreview',
    route : "/AccountReview",
    type : "SecondLevelMainMenuItem",
    key : 'accountreview',
    icon : <GradingIcon sx={{ color: "#546E7A" }} />,
    level : '4-3',
    isFinancial : true
  },
  {
    path:"/Invoice",
    element:(
        <PrivateRoute>
            <Layout>
            <Invoice />
          </Layout>
        </PrivateRoute>
    ),
    title : 'فاکتور فروش',
    name: 'invoice',
    route : "/Invoice",
    type : "SecondMenuItem",
    key : 'invoice',
    icon : <LoyaltyIcon sx={{ color: "#4CAF50" }} />,
    level : '',
    isFinancial : true
  },
  
  {
    path:"/Payment",
    element:(
        <PrivateRoute>
            <Layout>
              <Payment />
            </Layout>
        </PrivateRoute>
    ),
    title : 'پرداخت آنلاین',
    name: 'payment',
    route : "/Payment",
    type : "SecondLevelMainMenuItem",
    key : 'payment',
    icon : <AttachMoneyIcon sx={{ color: "#3F51B5" }} />,
    level : '4-4',
    isFinancial : true
  },
  
  {
    path:"/Payments",
    element:(
        <PrivateRoute>
            <Layout>
            <Receipts />
          </Layout>
        </PrivateRoute>
    ),
    title : 'پرداخت ها',
    name: 'payments',
    route : "/Payments",
    type : "SecondLevelMainMenuItem",
    key : 'payments',
    icon : <ListIcon sx={{ color: "#000000" }} />,
    level : '4-5',
    isFinancial : true
  },
  
  {
    path:"/SaleDepartment",
    element:(
        <PrivateRoute>
            <Layout>
            <SaleDepartment />
          </Layout>
        </PrivateRoute>
    ),
    title : 'زیر مجموعه من',
    name: 'saleDepartment',
    route : "/SaleDepartment",
    type : "SecondLevelMainMenuItem",
    key : 'saleDepartment',
    icon : <DeviceHub sx={{ color: "#ea80fc" }} />,
    level : '4-6',
    isFinancial : true
  },

  {
    path:"/ReturnedInvoice",
    element:(
        <PrivateRoute>
            <Layout>
            <ReturnedInvoice />
          </Layout>
        </PrivateRoute>
    ),
    title : 'فاکتور برگشتی',
    name: 'returnedinvoice',
    route : "/ReturnedInvoice",
    type : "SecondMenuItem",
    key : 'returnedinvoice',
    icon : <LoyaltyIcon sx={{ color: "#4CAF50" }} />,
    isFinancial : true
  },
  {
    path:"/PaymentResult/:c/:b/:c",
    element:(
        <PrivateRoute>
           
            <PaymentResult />
         
        </PrivateRoute>
    ),
    title : 'انتخاب از ماتریس',
    name: 'paymentresult',
    route : "/PaymentResult/:c/:b/:c",
    type : "SecondMenuItem",
    key : 'paymentresult',
    icon : <LoyaltyIcon sx={{ color: "#4CAF50" }} />,
    isFinancial : false
  },
  {
    path:"/ChangePass",
    element:(
        <PrivateRoute>
            <Layout>
            <ChangePass />
          </Layout>
        </PrivateRoute>
    ),
    title : 'تغییر رمز عبور',
    name: 'ChangePass',
    route : "/ChangePass",
    type : "FirtLevelMainMenuItem",
    key : 'ChangePass',
    icon : <PasswordIcon sx={{ color: "#546E7A" }} />,
    level : '6',
    isFinancial : false
  },
  {
    path:"/purchase",
   
  },
  {
    path:"/callback",
    element:(
        <PrivateRoute>
            <Layout>
            <CallBack />
          </Layout>
        </PrivateRoute>
    ),
    title : 'نتیجه ی پرداخت',
    name: 'callback',
    route : "/CallBack",
    type : "SecondMenuItem",
    key : 'callback',
    icon : <LoyaltyIcon sx={{ color: "#4CAF50" }} />,
    isFinancial : true
  },
  ...ApiAuthorzationRoutes
];

export default AppRoutes;
